// src/pages/AllVendors.js
import React, { useState, useEffect } from 'react';
import apiClient from '../services/api';

const AllVendors = () => {
  const [vendors, setVendors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchAllVendors();
  }, []);

  const fetchAllVendors = async () => {
    try {
      const cacheBuster = new Date().getTime();
      const response = await apiClient.get(`/admin/vendors/all?_t=${cacheBuster}`);
      setVendors(response.data.vendors);
    } catch (error) {
      console.error("Error fetching all vendors:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // 1. ONLINE / OFFLINE WALA BUTTON
  const handleToggleStatus = async (vendorId, currentStatus, shopName) => {
    const isCurrentlyOnline = currentStatus === true ? true : false;
    const action = isCurrentlyOnline ? "Force Offline" : "Make Online";
    const confirmToggle = window.confirm(`Are you sure you want to ${action} ${shopName}?`);
    
    if (!confirmToggle) return;

    try {
      await apiClient.put(`/admin/vendors/toggle-status/${vendorId}`);
      setVendors(vendors.map(vendor => {
        if (vendor._id === vendorId) return { ...vendor, isOnline: !isCurrentlyOnline };
        return vendor;
      }));
    } catch (error) {
      alert("Failed to change vendor status.");
    }
  };

  // 🔥 2. NAYA: SUSPEND / APPROVE WALA BUTTON 🔥
  const handleToggleApproval = async (vendorId, isApproved, shopName) => {
    const action = isApproved ? "SUSPEND / BAN" : "Approve";
    const confirmToggle = window.confirm(`Are you sure you want to ${action} ${shopName}?`);
    
    if (!confirmToggle) return;

    try {
      await apiClient.put(`/admin/vendors/toggle-approval/${vendorId}`);
      setVendors(vendors.map(vendor => {
        if (vendor._id === vendorId) {
          const newApprovalStatus = !isApproved;
          // Agar suspend kiya hai toh isOnline ko bhi false (offline) dikhao
          return { 
            ...vendor, 
            isProfileVerified: newApprovalStatus,
            isOnline: newApprovalStatus === false ? false : vendor.isOnline 
          };
        }
        return vendor;
      }));
    } catch (error) {
      alert("Failed to update approval status.");
    }
  };

  if (isLoading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
        <p>Loading Vendors Database...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-wrapper">
      <div className="page-header">
        <div>
          <h1 className="page-title">Vendor Management</h1>
          <p className="page-desc">View and manage all registered stores on PickupDrop.</p>
        </div>
      </div>

      <div className="data-card">
        <div className="table-header-bar">
          <h3 className="table-title">All Registered Vendors</h3>
          <span className="badge-count" style={{ backgroundColor: '#e2e8f0', color: '#1b254b' }}>
            Total: {vendors.length}
          </span>
        </div>

        <div className="table-responsive">
          <table className="modern-table">
            <thead>
              <tr>
                <th>Store & Owner</th>
                <th>Contact Details</th>
                <th>App Visibility</th>
                <th>Live Status</th>
                <th>Action Controls</th>
              </tr>
            </thead>
            <tbody>
              {vendors.map((vendor) => {
                const isApproved = vendor.isProfileVerified === true;
                const isOnline = vendor.isOnline === true;

                return (
                  <tr key={vendor._id}>
                    <td>
                      <div className="vendor-name">{vendor.shopName}</div>
                      <div className="vendor-sub">Owner: {vendor.name}</div>
                    </td>
                    <td>
                      <div style={{ color: '#1b254b', fontWeight: '600' }}>{vendor.phone}</div>
                      <div className="vendor-sub">{vendor.email}</div>
                    </td>
                    
                    {/* APP VISIBILITY */}
                    <td>
                      {isApproved ? (
                        <span className="status-badge" style={{ backgroundColor: '#e0f2fe', color: '#0284c7' }}>
                          👁️ Visible (Approved)
                        </span>
                      ) : (
                        <span className="status-badge" style={{ backgroundColor: '#ffedd5', color: '#c2410c' }}>
                          🙈 Hidden (Suspended)
                        </span>
                      )}
                    </td>

                    {/* LIVE STATUS */}
                    <td>
                      {isOnline ? (
                        <span className="status-badge" style={{ backgroundColor: '#dcfce7', color: '#166534' }}>
                          🟢 Online
                        </span>
                      ) : (
                        <span className="status-badge" style={{ backgroundColor: '#fee2e2', color: '#991b1b' }}>
                          🔴 Offline
                        </span>
                      )}
                    </td>

                    {/* 🔥 ACTION CONTROLS (DO BUTTONS) 🔥 */}
                    <td>
                      <div style={{ display: 'flex', gap: '10px', flexDirection: 'column', width: '130px' }}>
                        
                        {/* 1. Suspend / Approve Button */}
                        <button 
                          className="action-btn" 
                          style={{ 
                            borderColor: isApproved ? '#991b1b' : '#355ca9', 
                            color: isApproved ? '#991b1b' : '#355ca9',
                            backgroundColor: isApproved ? '#fee2e2' : '#f4f7fe'
                          }}
                          onClick={() => handleToggleApproval(vendor._id, isApproved, vendor.shopName)}
                        >
                          {isApproved ? '⛔ Suspend App' : '✅ Approve App'}
                        </button>

                        {/* 2. Make Online / Offline Button (Sirf tabhi dikhega jab account Approved ho) */}
                        {isApproved && (
                          <button 
                            className="action-btn" 
                            style={{ 
                              borderColor: isOnline ? '#ea6724' : '#22c55e', 
                              color: isOnline ? '#ea6724' : '#22c55e' 
                            }}
                            onClick={() => handleToggleStatus(vendor._id, vendor.isOnline, vendor.shopName)}
                          >
                            {isOnline ? '📴 Force Offline' : '📶 Make Online'}
                          </button>
                        )}

                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AllVendors;